import { Location, matchRoutes } from 'react-router-dom';
import { Person } from '../../../redux/Candidate/Candidate.type';
import { RoutesConstant } from '../../../constants/routes.constant';

const mergeNewPersonWithExistingPerson = (
  newPersonData: any,
  existingPersonData?: Person,
): any => {
  const {
    firstName,
    lastName,
    email,
    phone,
    experienceId,
    englishLevelId,
    links,
    tags,
    attachments,
  } = newPersonData || {};

  const getUniqLinks = () => {
    const existingPersonLinks = (existingPersonData?.links || []).map(link => ({
      ...link,
      tmpUUID: link.uuid,
    }));

    const existingLinksSet = new Set(
      existingPersonLinks.map(link => link.link)
    );
    
    const filteredLinks = (links || []).filter(
      (link: any) => !existingLinksSet.has(link.link)
    );

    return [...existingPersonLinks, ...filteredLinks];
  }

  return {
    id: existingPersonData?.id ? existingPersonData.id : undefined,
    lastName: lastName || existingPersonData?.lastName,
    firstName: firstName || existingPersonData?.firstName,
    email: email || existingPersonData?.email,
    phone: phone || existingPersonData?.phone,
    experienceId: experienceId || existingPersonData?.experience?.id,
    englishLevelId: englishLevelId || existingPersonData?.english?.id,
    attachments: [
      ...(existingPersonData?.attachments || []),
      ...(attachments || []),
    ],
    tags: [...(existingPersonData?.tags || []), ...(tags || [])].map(
      tag => tag.id,
    ),
    links: getUniqLinks(),
  };
};

const getUrlBasedOnCurrentPath = (
  location: Location,
  id: number | string,
  pathTemplate: string | string[],
  group?: string,
) => {
  let candidatesGroup = '';
  if (!group) {
    const pathArray = Array.isArray(pathTemplate)
      ? pathTemplate.map((template: string) => ({ path: template }))
      : [{ path: pathTemplate }];
    const routes = matchRoutes(pathArray, location.pathname);
    if (routes) {
      const [{ params }] = routes;
      candidatesGroup = params.group as string;
    }
  } else {
    candidatesGroup = group;
  }

  if (candidatesGroup) {
    return `${RoutesConstant.CANDIDATES}/${candidatesGroup}/${RoutesConstant.CANDIDATE_R}/${id}`;
  }
};

export { mergeNewPersonWithExistingPerson, getUrlBasedOnCurrentPath };